<h2 matDialogTitle>{{ data.title }}</h2>
<div mat-dialog-content>{{ data.message }}</div>
<div mat-dialog-actions>
  <span fxFlex></span>
  <button type="button" mat-raised-button color="primary2" style="box-shadow: none !important;" (click)="dialogRef.close(true)">OK</button>
</div>